<template>
  <q-layout class="bg-primary">
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: "AuthLayout"
}
</script>
<style scoped>
</style>
